export const profile = {
  name: 'Abraham Kuria',
  title: 'Mobile Software Engineer',
  photo: '/images/avatar.jpg',
  photoPosition: '50% 35%',
  email: 'abrahamkuria9@gmail.com',
  phone: '+254 769 629 949',
  linkedin: 'https://www.linkedin.com/in/abraham-kimani-7371391b7/',
  github: 'https://github.com/Abrahamkimani',
  summary: `Mobile engineer with production experience building large-scale consumer applications including ride-hailing and fintech-enabled platforms handling thousands of daily active users. Proven track record of architecting real-time systems, implementing secure payment processing, and optimizing application performance. Experienced in cross-functional collaboration with product, design, and infrastructure teams to deliver features that reach millions of users.`,
};

export const skills = {
  languages: ['Objective-C', 'Swift', 'Kotlin', 'Java', 'Python'],
  mobile: ['Flutter', 'React Native', 'UIKit', 'Core Data', 'Core Location', 'Core Animation', 'Cocoa Touch', 'Android SDK', 'MVVM', 'MVC'],
  backend: ['REST APIs', 'WebSockets', 'Firebase (FCM, Realtime DB)', 'JWT authentication', 'Session management'],
  realTime: ['Push notifications', 'WebSocket services', 'Tencent IM', 'Real-time order tracking'],
  performance: ['Instruments', 'Memory profiling', 'Battery optimization', 'Network latency reduction'],
  payments: ['M-Pesa STK Push', 'Wallet systems', 'Payment verification', 'Transaction reconciliation'],
  infrastructure: ['Git', 'CI/CD', 'Fastlane', 'Multi-environment configurations', 'Staged rollouts'],
};

export const experience = [
  {
    company: 'Cab Yetu',
    tagline: 'Ride-Hailing Platform — 10K+ Monthly Active Users',
    period: 'Nov 2025 – Present',
    logo: '/images/logos/cab-yetu.png',
    roles: [
      {
        title: 'iOS Engineer',
        stack: 'Objective-C, Swift',
        bullets: [
          'Architect and maintain dual iOS applications (User & Driver) serving thousands of daily active users, ensuring high performance, reliability, and adherence to Apple\'s Human Interface Guidelines.',
          'Implemented offline persistence using Core Data for ride history and trip records, enabling users to access past trips without network connectivity and reducing redundant API calls by 30%.',
          'Built custom high-performance UI components using UIKit programmatic views with Auto Layout, maintaining 60fps rendering across all device sizes and orientations.',
          'Designed real-time order lifecycle system using WebSockets and push notifications, processing thousands of concurrent ride requests with sub-second latency.',
          'Integrated Google Maps SDK with Core Location for real-time driver tracking, route rendering, and geocoding—handling location updates for 500+ concurrent drivers.',
          'Profiled and optimized memory usage using Instruments, identifying and resolving memory leaks in tracking modules, reducing crash rate by approximately 25%.',
          'Implemented multi-payment integration including M-Pesa STK Push, wallet systems, and loyalty points with polling-based verification and comprehensive error handling.',
          'Managed end-to-end App Store releases through App Store Connect, including TestFlight beta distribution and staged production rollouts.',
        ],
      },
      {
        title: 'Android Engineer',
        stack: 'Kotlin',
        bullets: [
          'Developed companion Android applications using Kotlin with MVVM architecture, supporting 200+ API endpoints and serving same user base as iOS platform.',
          'Implemented Google Maps SDK with marker clustering and real-time tracking for 500+ concurrent drivers.',
          'Integrated Firebase Cloud Messaging (FCM) and WebSocket services for cross-platform real-time updates, processing thousands of daily notifications.',
          'Built multi-payment integration with comprehensive verification and failure handling for financial transactions.',
          'Automated CI/CD using Fastlane with multi-environment configurations (Dev/Staging/Production) and staged Play Store releases.',
        ],
      },
    ],
  },
  {
    company: 'Fua Chap Chap',
    tagline: 'Laundry Platform — Founder & product from scratch',
    period: 'Oct 2024 – Present',
    logo: '/images/logos/fua-chap-chap.png',
    roles: [
      {
        title: 'Founder & Mobile Engineer',
        stack: 'Full-time',
        bullets: [
          'Lead the business with a focus on efficiency, quality, and customer satisfaction; oversee daily operations and customer-centered culture.',
          'Built production Android application handling user orders, payments, and real-time messaging with offline-first architecture.',
          'Engineered offline-first messaging system using Firebase Realtime Database with local message queue and automatic synchronization—ensuring reliable communication even with intermittent connectivity.',
          'Designed secure networking layer with OkHttp interceptors handling CSRF tokens, session cookies, and encrypted local storage.',
          'Implemented robust M-Pesa payment verification using coroutine-based polling with comprehensive failure handling and transaction reconciliation.',
          'Developed dynamic pricing engine and duplicate order detection algorithms to prevent fraud and ensure data integrity.',
        ],
      },
    ],
  },
  {
    company: 'MOVE WITH SONGA',
    tagline: 'Co-Founder',
    period: 'May 2024 – Present',
    logo: null,
    roles: [
      {
        title: 'Co-Founder',
        stack: 'Full-time · On-site, Nairobi',
        bullets: [
          'Co-founded and help run the venture; building product and operations from the ground up.',
        ],
      },
    ],
  },
  {
    company: 'Google',
    tagline: 'Developer Groups & Developer Student Clubs',
    period: 'Sep 2024 – Sep 2025 · 1 yr',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
    roles: [
      {
        title: 'Co-Lead GDG On Campus',
        stack: 'Full-time · Nairobi',
        bullets: [
          'Organize and lead events that foster learning and collaboration in tech; help students engage with Google technologies, develop skills, and connect with the developer community.',
        ],
      },
    ],
  },
  {
    company: 'red(P)',
    tagline: 'Software engineering',
    period: 'Jun 2025 – Aug 2025 · 3 mos',
    logo: '/images/logos/red-p.png',
    roles: [
      {
        title: 'Software Engineer',
        stack: 'Internship · Remote, US',
        bullets: [
          'Software engineering internship; contributed to product development in a remote, cross-border setting.',
        ],
      },
    ],
  },
  {
    company: 'Techno Brain Group',
    tagline: 'QA & embedded systems',
    period: 'Jul 2024 – Sep 2024 · 3 mos',
    logo: '/images/logos/techno-brain.png',
    roles: [
      {
        title: 'Software Tester Engineer',
        stack: 'Internship · Nairobi',
        bullets: [
          'QA engineering, testing, and embedded systems; worked with Windows IoT, 3D printing, and C#.',
        ],
      },
    ],
  },
  {
    company: 'Google Developer Student Clubs',
    tagline: 'University of Nairobi',
    period: 'Aug 2022 – Jun 2024',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
    roles: [
      {
        title: 'IoT Lead GDSC',
        stack: 'Aug 2023 – Jun 2024 · 11 mos',
        bullets: [
          'Led IoT initiatives and community activities within the developer student club.',
        ],
      },
      {
        title: 'Blockchain Lead GDSC',
        stack: 'Sep 2022 – Aug 2023 · 1 yr',
        bullets: [
          'Blockchain education and workshops; networking and community building; project development and collaboration. Smart contract programming, event planning, and leadership.',
        ],
      },
    ],
  },
];

export const leadership = [
  'Drove architectural decisions for real-time messaging system, choosing Firebase Realtime Database over traditional REST to reduce latency by 40% for chat features.',
  'Led performance optimization initiative for Cab Yetu iOS app, using Instruments to identify and fix memory leaks, reducing crash rate from 3.2% to 0.8%.',
  'Mentored junior engineers through code reviews and pair programming, establishing coding standards and best practices for the mobile team.',
  'Used data-driven approach to solve problems: analyzed crash reports, user analytics, and performance metrics to prioritize fixes and feature improvements.',
  'Reduced technical debt by refactoring legacy Objective-C view controllers into modular, testable components following MVC architecture.',
  'Took ownership of critical system components including payment processing, real-time tracking, and notification services—ensuring 99.5% uptime.',
];

export const education = {
  school: 'University of Nairobi',
  degree: 'B.Sc. Microprocessor Technology and Instrumentation',
  honour: 'Second Class Honours (Upper Division)',
  logo: '/images/logos/university-nairobi.png',
};

export const projects = [
  {
    title: 'GDG Campus — Co-Lead',
    description: 'Led technical workshops for 50+ students on mobile development and system design. Organized hackathons emphasizing scalable application development and real-world problem solving. Built community around mobile engineering best practices.',
  },
  {
    title: 'Cab Yetu Platform',
    description: 'Production ride-hailing apps with real-time backend (10K+ users).',
    links: [
      { label: 'iOS TestFlight', url: 'https://testflight.apple.com/join/n2YFSqTk' },
      { label: 'Android Driver', url: 'https://play.google.com/store/apps/details?id=com.taxi.yetu.driver' },
      { label: 'Android User', url: 'https://play.google.com/store/apps/details?id=com.taxi.yetuuser' },
    ],
  },
  {
    title: 'Fua Chap Chap',
    description: 'Production operational platform with offline-first architecture.',
    links: [
      { label: 'Google Play Link', url: 'https://play.google.com/store/apps/details?id=com.fuachapchap.app' },
    ],
  },
  {
    title: 'Open Source & Code',
    description: 'Additional projects and repositories.',
    links: [
      { label: 'GitHub Profile', url: 'https://github.com/Abrahamkimani' },
    ],
  },
];

export const highlights = [
  'Scalable Systems',
  'Real-Time Architecture',
  'Performance Optimization',
  'Cross-Functional Collaboration',
];
